export default function getFeatureAppId(isShowroom: boolean): string {
    const FEATURE_APP_STANDALONE = 'Promozioni-Standalone-D6-IT'
    const FEATURE_APP_SHOWROOM = 'PromozioniShowroom-D6-IT'

    return isShowroom ? FEATURE_APP_SHOWROOM : FEATURE_APP_STANDALONE
}
